/** Ticket copy when referral code is missing, invalid, or tampered. */
export const INVITATION_REQUIRED_MESSAGE =
  'Invalid or missing invitation link. You must have a valid invitation to sign up.';

export function readStoredEuId(): string | null {
  if (typeof window === 'undefined' || typeof window.localStorage?.getItem !== 'function') {
    return null;
  }

  try {
    const value = window.localStorage.getItem('euId');
    if (typeof value !== 'string') {
      return null;
    }

    const trimmed = value.trim();
    return trimmed !== '' ? trimmed : null;
  } catch {
    return null;
  }
}
